export const CHECKBOX_VARIANTS = {
	container: {
		checked: {
			backgroundColor: '#0a0a0a',
		},
		default: {
			backgroundColor: '#ffffff',
		},
	},
	content: {
		checked: {
			backgroundColor: '#ffffff',
			left: 32,
		},
		default: {
			backgroundColor: '#0a0a0a',
			left: 2.5,
		},
	},
};
